
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/work-management",
      function () {
        return require("private-next-pages/work-management/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/work-management"])
      });
    }
  